import CryptoJS from 'crypto-js';

// Секретный ключ для генерации пароля
const SECRET_KEY = 'enode-secret-2024';

/**
 * Генерирует пароль на основе 15-дневного периода
 * @param {string} secret - дополнительный секретный ключ (опционально)
 * @returns {string} - сгенерированный пароль
 */
export const generateDailyPassword = (secret = '') => {
  // Получаем текущую дату
  const today = new Date();
  
  // Вычисляем номер 15-дневного периода с начала года
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const daysSinceStart = Math.floor((today - startOfYear) / (1000 * 60 * 60 * 24));
  const periodNumber = Math.floor(daysSinceStart / 15);
  
  // Создаем строку для хеширования: год + номер периода + секретный ключ + дополнительный секрет
  const hashInput = `${today.getFullYear()}-${periodNumber}-${SECRET_KEY}-${secret}`;
  
  // Генерируем SHA-256 хеш
  const hash = CryptoJS.SHA256(hashInput).toString();
  
  // Берем первые 8 символов и делаем их более читаемыми
  const password = hash.substring(0, 8).toUpperCase();
  
  return password;
};

/**
 * Проверяет, является ли введенный пароль правильным для текущего 15-дневного периода
 * @param {string} inputPassword - пароль для проверки
 * @param {string} secret - дополнительный секретный ключ (опционально)
 * @returns {boolean} - true если пароль правильный
 */
export const validatePassword = (inputPassword, secret = '') => {
  const correctPassword = generateDailyPassword(secret);
  return inputPassword.toUpperCase() === correctPassword;
};

/**
 * Получает пароль для конкретной даты (для отладки/администрирования)
 * @param {string} dateString - дата в формате YYYY-MM-DD
 * @param {string} secret - дополнительный секретный ключ (опционально)
 * @returns {string} - пароль для указанной даты
 */
export const getPasswordForDate = (dateString, secret = '') => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  
  // Вычисляем номер 15-дневного периода с начала года
  const startOfYear = new Date(year, 0, 1);
  const daysSinceStart = Math.floor((date - startOfYear) / (1000 * 60 * 60 * 24));
  const periodNumber = Math.floor(daysSinceStart / 15);
  
  const hashInput = `${year}-${periodNumber}-${SECRET_KEY}-${secret}`;
  const hash = CryptoJS.SHA256(hashInput).toString();
  return hash.substring(0, 8).toUpperCase();
};

/**
 * Получает информацию о текущем пароле
 * @returns {object} - объект с информацией о пароле
 */
export const getPasswordInfo = () => {
  const today = new Date();
  const dateString = today.toISOString().split('T')[0];
  const password = generateDailyPassword();
  
  // Вычисляем информацию о периоде
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const daysSinceStart = Math.floor((today - startOfYear) / (1000 * 60 * 60 * 24));
  const periodNumber = Math.floor(daysSinceStart / 15);
  const daysInCurrentPeriod = daysSinceStart % 15;
  const daysRemaining = 15 - daysInCurrentPeriod - 1;
  
  // Вычисляем даты начала и конца периода
  const periodStart = new Date(startOfYear.getTime() + periodNumber * 15 * 24 * 60 * 60 * 1000);
  const periodEnd = new Date(periodStart.getTime() + 14 * 24 * 60 * 60 * 1000);
  
  return {
    date: dateString,
    password: password,
    timestamp: today.toISOString(),
    periodNumber: periodNumber,
    daysRemaining: daysRemaining,
    periodStart: periodStart.toISOString().split('T')[0],
    periodEnd: periodEnd.toISOString().split('T')[0]
  };
};
